<template>
  <v-card class="mb-4">
    <v-card-title class="d-flex align-center justify-space-between">
      <span>
        <v-icon class="mr-2" color="orange">mdi-chart-bar</v-icon>
        {{ t.dashboard?.services_stats || 'Services Statistics' }}
      </span>
      <v-btn
        icon
        size="small"
        variant="text"
        :loading="rebuilding"
        @click="rebuildStats"
        :title="t.dashboard?.recalculate_stats || 'Recalculate statistics'"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-progress-circular v-if="loading" indeterminate size="24" class="mr-2" />

      <v-row v-else>
        <v-col cols="6" md="3">
          <v-card variant="tonal" color="success" class="text-center pa-3">
            <div class="text-h4">{{ stats.active || 0 }}</div>
            <div class="text-caption">{{ t.dashboard?.active || 'Active' }}</div>
          </v-card>
        </v-col>
        <v-col cols="6" md="3">
          <v-card variant="tonal" color="warning" class="text-center pa-3">
            <div class="text-h4">{{ stats.expiring_soon || 0 }}</div>
            <div class="text-caption">{{ t.dashboard?.expiring_soon || 'Expiring soon' }}</div>
          </v-card>
        </v-col>
        <v-col cols="6" md="3">
          <v-card variant="tonal" color="error" class="text-center pa-3">
            <div class="text-h4">{{ stats.expired || 0 }}</div>
            <div class="text-caption">{{ t.dashboard?.expired || 'Expired' }}</div>
          </v-card>
        </v-col>
        <v-col cols="6" md="3">
          <v-card variant="tonal" color="grey" class="text-center pa-3">
            <div class="text-h4">{{ stats.terminated || 0 }}</div>
            <div class="text-caption">{{ t.dashboard?.terminated || 'Terminated' }}</div>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { t as tRef } from '@/composables/useLanguages'
import { getClientServicesStats } from '@/composables/useGetClientServicesAPI'
import { rebuildClientStatistics } from '@/composables/useDisplaySettingsAPI'
import store from '@/store'

export default {
  name: 'ServicesStatsSection',
  props: {
    config: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      stats: {},
      loading: true,
      rebuilding: false
    }
  },
  computed: {
    t() { return tRef.value },
    token() {
      return store.getters.getToken
    }
  },
  async mounted() {
    await this.loadStats()
  },
  methods: {
    async loadStats() {
      this.loading = true
      try {
        const result = await getClientServicesStats(this.token)
        if (!result.error) {
          this.stats = result.stats || {}
        }
      } finally {
        this.loading = false
      }
    },
    async rebuildStats() {
      this.rebuilding = true
      try {
        await rebuildClientStatistics(this.token)
        setTimeout(() => this.loadStats(), 2000)
      } finally {
        this.rebuilding = false
      }
    }
  }
}
</script>
